<template>
  <div v-show="config.show" v-finger:swipe="onSwipe" class="my-container">
    <div v-show="!isDesktop" class="header">
      <div class="left">
        <el-button class="tap-btn" @click="goto('index')">
          <i class="iconfont my-back" />
        </el-button>
      </div>
      <div class="middle">
        {{ $t('i.start_aigc') }}
      </div>
      <div class="right">
        <el-button class="tap-btn" @click="emit('openSift', ['aiart'])">
          <i class="iconfont my-filter" />
        </el-button>
      </div>
    </div>
    <aiart-list
      ref="aiart-flow"
      mod="flow"
      :view="view"
      :state="state"
      :subtract-height="isDesktop ? 5 : 45"
      :login-status="loginStatus"
      :login-user-id="loginUserId"
      @receive="handle"
    />
    <aipost
      ref="aiart-aipost"
      mod="aiart-aipost"
      :view="view"
      :state="state"
      :login-status="loginStatus"
      :login-user-id="loginUserId"
      @receive="handle"
    />
    <div v-show="isDesktop" class="aiart-sift">
      <el-button class="tap-btn" @click="emit('openSift', ['aiart'])">
        {{ config.originName }}
        <i class="iconfont my-filter" />
      </el-button>
    </div>
    <div v-show="loading" class="aiart-loading">
      <div>
        <i class="el-icon-loading white" />
        {{ $t('i.queuein') }}
      </div>
    </div>
  </div>
</template>
<script>
import aiartList from '@/components/web/aiartList'
import aipost from '@/components/web/aipost'
import { mixins } from '@/mixins/common'
export default {
  components: {
    aiartList,
    aipost
  },
  mixins: [mixins],
  data() {
    const data = {
      loading: false
    }
    return data
  },
  computed: {
    config() {
      return this.view.aiart
    },
    types() {
      return this.config.types()
    }
  },
  watch: {
    'view.aiart.show': {
      handler(show) {
        if (show) {
          if (this.loginUserId) {
            this.renewView()
          } else {
            this.emit('login')
            this.resetData()
            this.goto('index')
          }
        }
      }
    },
    'loginUserId': {
      handler(userid) {
        if (this.view.aiart.show) {
          if (userid) {
            this.renewView()
          } else {
            this.resetData()
          }
        }
      }
    }
  },
  mounted() {},
  methods: {
    handle(act, data) {
      if (act === 'loading') {
        this.loading = true
        setTimeout(() => {
          this.loading = false
          this.renewView()
        }, 20000)
      } else if (act === 'quoteIt') {
        this.callSub('aiart-aipost', 'quoteIt', data)
      } else if (act === 'reEdit') {
        this.callSub('aiart-aipost', 'reEdit', data)
      } else if (act === 'rePost') {
        this.callSub('aiart-aipost', 'rePost', data)
      } else {
        this.emit(act, data)
      }
    },
    onSwipe(evt) {
      this.switchTab(this.config, evt.direction)
    },
    renewView() {
      const el = this.$refs['aiart-' + this.config.type]
      if (el) el.renewView()
    },
    resetData() {
      const el = this.$refs['aiart-' + this.config.type]
      if (el) el.resetData()
    }
  }
}
</script>
